import { createContext, type ReactNode, useContext, useEffect, useState } from "react";
import { IntlProvider } from "use-intl";

import { initialLocale, type Locale, messages, STORAGE_KEY, TIME_ZONE } from "./config";

const LocaleContext = createContext<{
	locale: Locale;
	setLocale: (l: Locale) => void;
} | null>(null);

export function I18nProvider({ children }: { children: ReactNode }) {
	const [locale, setLocale] = useState<Locale>(initialLocale);

	useEffect(() => {
		document.documentElement.lang = locale;
	}, [locale]);

	const change = (next: Locale) => {
		setLocale(next);
		localStorage.setItem(STORAGE_KEY, next);
	};

	return (
		<LocaleContext.Provider value={{ locale, setLocale: change }}>
			<IntlProvider locale={locale} messages={messages[locale]} timeZone={TIME_ZONE}>
				{children}
			</IntlProvider>
		</LocaleContext.Provider>
	);
}

export function useLocaleSwitcher() {
	const ctx = useContext(LocaleContext);
	if (!ctx) throw new Error("useLocaleSwitcher must be used within <I18nProvider>");
	return ctx;
}
